<template>
  <div class="contancts-wrapper">
    <v-col cols="12" md="2" class="contacts-list">
      <v-switch
        class="px-4"
        v-model="historico"
        label="Chats Historicos"
        inset
        v-if="verHistorico"
        hide-details
        dense
        color="primary"
      ></v-switch>
      <v-switch
        class="px-4"
        v-model="chatsActivos"
        label="Chats Activos"
        inset
        hide-details
        dense
        color="primary"
      ></v-switch>
      <v-text-field
        v-model="search"
        dense
        outlined
        hide-details
        prepend-inner-icon="fa-search"
        label="Buscar contacto"
        class="py-2 pt-4"
      />
      <v-data-table
        :headers="headers"
        :items="contactos"
        :search="search"
        item-key="numero"
        dense
        hide-default-header
        class="elevation-0"
        :footer-props="footerProps"
      >
        <template v-slot:no-data>
          <div class="pa-3 text-center grey--text">
            Aún no se han agregado contactos...
          </div>
        </template>

        <template v-slot:item="{ item }">
          <tr
            @click="selectedNumber = item.numero"
            style="cursor: pointer; position: relative"
            :class="{
              'grey lighten-4': selectedNumber === item.numero,
            }"
          >
            <td class="pa-0 pl-3 ma-0" style="width: 60px">
              <v-avatar size="35" rounded color="grey lighten-2">
                <v-img src="@/assets/no_logo_user.png" />
              </v-avatar>
            </td>

            <td class="pa-1 font-weight-bold">
              <div>
                <span>{{ item.nombre }}</span>
              </div>
              <span class="caption">{{ item.numero }}</span>
            </td>

            <v-chip
              v-if="item.unreadCount > 0"
              color="green"
              dark
              x-small
              class="unread-chip px-1"
            >
            </v-chip>
          </tr>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12" md="10" class="pa-0 ma-0">
      <WhatsAppChat
        :numero="selectedNumber"
        v-if="selectedNumber"
        class="pr-3"
        :historico="historico"
      />
      <div
        v-else
        class="number-not-selected d-flex align-center justify-center flex-grow-1"
      >
        No se han seleccionado chats...
      </div>
    </v-col>
  </div>
</template>

<script>
import Axios from "axios";
import WhatsAppChat from "./Minis/WhatsAppChat.vue";

export default {
  data: () => ({
    selectedNumber: "",
    search: "",
    itemsPerPage: 10,
    historico: false,
    chatsActivos: true,
    allChats: [],
    allActiveChats: [],
    headers: [
      { text: "", value: "avatar", sortable: false },
      { text: "", value: "nombre", sortable: false },
      { text: "Contactos", value: "numero", sortable: false },
    ],
    footerProps: {
      "items-per-page-options": [5, 10, 20],
      "items-per-page-text": "Contactos por página",
    },
  }),
  components: {
    WhatsAppChat,
  },
  watch: {
    historico(val) {
      if (val) {
        if (this.chatsActivos) this.chatsActivos = false;
      }
    },
    selectedNumber(numero) {
      this.$store.commit("MARK_AS_READ", numero);
    },
    chatsActivos(val) {
      if (val) {
        if (this.historico) this.historico = false;
      }
      this.getAllContacts();
    },
  },
  computed: {
    contactos() {
      if (this.chatsActivos) {
        this.$store.commit("SET_CONTACTS", this.allActiveChats);

        let chats = this.$store.getters.chatsOrdenados;
        return chats;
      } else {
        return this.allChats;
      }
    },
    verHistorico() {
      if (this.$store.state.usuario) {
        return (
          this.$store.state.usuario.rol == "Administrador" ||
          this.$store.state.usuario.rol == "Personal Administrativo" ||
          this.$store.state.usuario.rol == "Team Leader Cabina" ||
          this.$store.state.usuario.rol == "Admin Proveedores"
        );
      }
      return null;
    },
  },
  created() {
    this.getAllContacts();
  },
  methods: {
    getAllContacts() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.chatsActivos) {
        Axios.get("api/MetaAPI/active-chats", configuracion)
          .then((res) => {
            this.$store.commit("SET_CONTACTS", res.data);
            this.allActiveChats = res.data;
            // selección inicial
            if (res.data.length > 0) {
              const telefono = this.$route.params.telefono;
              this.selectedNumber = telefono ?? res.data[0].numero;
              this.search = telefono ?? "";
            }
          })
          .catch(console.error);
      } else {
        Axios.get("api/ContactsWA", configuracion)
          .then((res) => {
            this.allChats = res.data;
            if (res.data.length > 0) {
              const telefono = this.$route.params.telefono;
              this.selectedNumber = telefono ?? res.data[0].numero;
              this.search = telefono ?? "";
            }
          })
          .catch(console.error);
      }
    },
  },
};
</script>
<style scoped>
.unread-chip {
  position: absolute;
  left: 44px;
  top: 13px;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 15px;
}

.number-not-selected {
  position: absolute;
  left: 50%;
  top: 50%;
}
.contancts-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0;
}
.contacts-list {
  height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 10px 4px;
}
</style>